var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"train-category",class:{'selectable': _vm.selectable, 'selected': _vm.internalSelected},style:(_vm.itemStyle),attrs:{"title":_vm.category.title},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.category.display_name))])}
var staticRenderFns = []

export { render, staticRenderFns }